import React, { useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  TextField,
  Grid,
  Typography,
  Box,
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import validationRules from '../../utils/validations.util';
import Iconify from '../common/iconify.component';
import SnackbarInfo from '../common/snackbar-info.component';
import { saveNewChannelSchedule } from '../../services/ruleset.service';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const NewChannelSchedule = ({ title, channelId, onCancel, onSuccess }) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [snackbarInfo, setSnackbarInfo] = useState({
    show: false,
    type: '',
    message: '',
  });

  const onFormSubmit = (data) => {
    setFormSubmitted(true);
    setSnackbarInfo({
      ...snackbarInfo,
      show: false,
    });

    const payload = {
      numberOfWeeks: Number(data.numberOfWeeks) || 0,
    };
    saveNewChannelSchedule(channelId, payload)
      .then(() => {
        onSuccess('New channel Schedule saved successfully.');
      })
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          'Something went wrong, please try again.';

        setSnackbarInfo({
          ...snackbarInfo,
          show: true,
          type: 'error',
          message,
        });
        setFormSubmitted(false);
      });
  };

  return (
    <Dialog
      open
      aria-labelledby="add-dialog-title"
      aria-describedby="add-dialog-description"
      TransitionComponent={Transition}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="add-dialog-title">{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        size="small"
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Iconify icon="ic:outline-close" />
      </IconButton>

      <DialogContent dividers id="add-dialog-description">
        <form id="add-edit-form" onSubmit={handleSubmit(onFormSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Typography variant="body2" color="secondary">
                All scheduled dates will be shifted back by the entered number
                of weeks.
              </Typography>
              <Typography variant="body2" color="secondary">
                Hero content will always move back by 1 week.
              </Typography>
              <Typography variant="body2" color="secondary">
                Enter the number of weeks you want to move the schedule into the
                past.
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Controller
                name="numberOfWeeks"
                control={control}
                rules={validationRules.REQUIRED}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Number of Weeks *"
                    type="number"
                    error={!!errors.numberOfWeeks}
                    helperText={errors?.numberOfWeeks?.message || null}
                    fullWidth
                    variant="filled"
                    sx={{ mt: 1 }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Box width="100%" display="flex" justifyContent="flex-end">
                <Button
                  type="submit"
                  form="add-edit-form"
                  color="primary"
                  variant="contained"
                  disabled={formSubmitted}
                >
                  Shift Schedule Earlier
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </DialogContent>

      {snackbarInfo.show && (
        <SnackbarInfo type={snackbarInfo.type} message={snackbarInfo.message} />
      )}
    </Dialog>
  );
};

NewChannelSchedule.propTypes = {
  title: PropTypes.string.isRequired,
  channelId: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default NewChannelSchedule;
